import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-kunde-subnummer.master-view.html',
    styleUrls: ['./ktostamm-kunde-subnummer.master-view.scss']
})
export class KtostammKundeSubnummerMasterView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
